<div class="bc-discussion-widget column-flex-container bc-work-item-theme {{discussionThemeClass}}">
  <div class="discussion-widget-content column-flex-grow multilane-wrapper panel-shadow-wrapper">
    <div class="multilane-item multilane-item-1 bc-work-lane">
      <work-widget-header class="bc-panel" *ngIf="workItem" [workItem]="workItem" [title]="workItem.OperatorName"></work-widget-header>
      <app-discussions
        [workItemId]="workItem.WorkItemID"
        [helperDiscussionId]="workItem.DiscussionID"
        [workItemType]="workItem.type">
      </app-discussions>
    </div>

    <div class="discussion-work-item-wrapper" [ngClass]="subWorkItemThemeClass">
      <app-preview-header class="bc-panel" *ngIf="workItem"
                          [workItemId]="workItem.WorkItemID"
                          [workItemType]="getSubWorkItemType()">
      </app-preview-header>
      <div class="discussion-chat-content multilane-wrapper">
        <div class="multilane-item bc-work-lane multilane-item-1" *ngIf="isWorkItemChat">
          <app-chat-box class="bc-panel-maxh" *ngIf="chat && subWorkItem" [chat]="chat"
                        [isCannedMessagePanelOpen]="false" [workItem]="subWorkItem"
                        [isDiscussionPanelOpened]="false" [hideWrapUpPanel]="true"
                        [canJoinChat]="true" tabindex="-1"></app-chat-box>
        </div>
        <div class="multilane-item bc-work-lane multilane-item-2" *ngIf="isWorkItemEmail && lastEmail">
          <app-email-viewer class="bc-panel" [email]="lastEmail"></app-email-viewer>
        </div>

        <div class="multilane-item bc-work-lane multilane-item" [attr.data-automation-id]="'VISITOR_INFO_PANEL'">
          <app-compact-visitor-info [visitor]="visitor" class="bc-panel"></app-compact-visitor-info>
          <app-visitor-history class="bc-panel"
                              *ngIf="chat"
                              [chatId]="chat.ChatID">
          </app-visitor-history>
          <app-visitor-history class="bc-panel"
                               *ngIf="emailThread && lastEmail"
                               [emailThreadId]="emailThread.id"
                               [emailId]="lastEmail.id"></app-visitor-history>
        </div>
      </div>
    </div>
  </div>
</div>
